import { ORDER_HISTORY_MONTHS_PATH, SCHOOL_ORDER_HISTORY_MONTHS_PATH } from "../../functions/src/admin/paths";
import { useDatabaseVal } from "./firebaseHooks";

export const DEFAULT_ORDER_HISTORY_MONTHS = 3;

export function parseOrderHistoryMonths(value: unknown): number | undefined {
    if (value == null || value === "") return undefined;
    const n = Number(value);
    return Number.isFinite(n) && n > 0 ? n : undefined;
}

/** School `schoolConfig/history/orderHistoryMonths` overrides main `resources/history/orderHistoryMonths`. */
export function useOrderHistoryMonths(): number {
    const [schoolMonths] = useDatabaseVal<number | null>(SCHOOL_ORDER_HISTORY_MONTHS_PATH);
    const [globalMonths] = useDatabaseVal<number | null>(ORDER_HISTORY_MONTHS_PATH);
    return parseOrderHistoryMonths(schoolMonths) ?? parseOrderHistoryMonths(globalMonths) ?? DEFAULT_ORDER_HISTORY_MONTHS;
}
